import { MessageBox } from 'element-ui'
import { Message } from 'element-ui'

import axios from 'axios'
import config from './request.config.js'
import store from '@/store'
import router from '@/router'

// 创建axios实例
const service = axios.create(config)
var timer

// request拦截器
service.interceptors.request.use(
  config => {
    // 发出请求前的处理
    config.headers['managerSessionKey'] = store.getters.managerSessionKey
    config.headers['sessionKey'] = store.getters.sessionKey
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  // 如果您想要获取诸如头或状态之类的http信息
  // 请返回response=>response
  response => {
    // 处理下载后返回的流
    if (response.headers['content-disposition']) {
      const disposition = response.headers['content-disposition']
      let fileName = disposition.substring(
        disposition.indexOf('filename=') + 9,
        disposition.length
      )
      fileName = decodeURI(fileName)
      const blob = new Blob([response.data])

      return Promise.resolve({
        blobLink: URL.createObjectURL(blob),
        fileName
      })
    } else if (response.data) {
      if (response.data.retCode === '401') {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => Message('登录过期'), 1000)
        store.dispatch('cust/logout').then(() => router.push('/login'))
        return Promise.reject(response.data.retMsg)
      } else if (!response.data.return_code) {
        return Promise.resolve(response.data)
      } else if (response.data.return_code === 0) {
        return Promise.resolve(response.data)
      } else if (
        response.data.return_code === 'errorCode' ||
        response.data.return_code.toString().slice(0, 1) === '5'
      ) {
        if (
          response.config.url !=
            '/yazb-cust/OptionOrder/checkUserHasOrderFinish' &&
          response.config.url != '/yazb-cust/OptionOrder/selectActualPrice' &&
          response.config.url !=
            '/yazb-cust/stockOrder/checkUserHasOrderFinish' &&
          response.config.url != '/yazb-cust/stockOrder/selectActualPrice' &&
          response.config.url != '/yazb-cust/stockOrder/getNoticlRecordList'
        ) {
          MessageBox.alert(response.data.error_info, '提示', { type: 'error' })
        }

        return Promise.reject(response.data.error_info)
      } else if (response.data.return_code === 'CP01') {
        return Promise.reject(response.data)
      } else {
        return Promise.resolve(response.data)
      }
    }
  },
  error => {
    if (error.response.status == 500) {
      if (
        error.config.url == '/yazb-cust/OptionOrder/checkUserHasOrderFinish' ||
        error.config.url == '/yazb-cust/OptionOrder/selectActualPrice' ||
        error.config.url == '/yazb-cust/stockOrder/checkUserHasOrderFinish' ||
        error.config.url == '/yazb-cust/stockOrder/selectActualPrice' ||
        error.config.url == '/yazb-cust/stockOrder/getNoticlRecordList'
      ) {
        return Promise.reject(error)
      } else {
        MessageBox.alert(error.response.message, '返回异常', { type: 'error' })
        return Promise.reject(error)
      }
    } else if (error.response.status == 405) {
      MessageBox.alert(error.response.message, '接口类型错误', {
        type: 'error'
      })
    }
    return Promise.reject(error)
  }
)
const PUBLIC_API = '/yazb-cust'

export default {
  post (url, data, params = {}) {
    url = PUBLIC_API + url
    return service({
      method: process.env.VUE_APP_ENV_METHOD,
      url,
      params,
      data: data
    })
  },
  get (url, data) {
    url = PUBLIC_API + url
    return service({
      method: 'get',
      url,
      params: data
    })
  },
  // 自定义报头请求
  customService (url, config) {
    // 文件下载,添加请求信息,用于日志记录
    if (store && store.getters && store.getters.custId) {
      if (!config.params) {
        config.params = {}
      }
      config.params.login_id = store.getters.custId
    }

    // config.params.user_name =  store.getters.userName
    return service({
      url: PUBLIC_API + url,
      ...config
    })
  },

  fileUpload (fileobj) {
    let param = new FormData()
    // 上传文件对象 名称file与后台控制器参数要一致
    param.append('fileupload', fileobj.file)
    return service({
      method: 'post',
      // 上传地址
      url: PUBLIC_API + '/FileController/FileUploadFlow',
      // 定义上传头
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: param
    })
  },
  fileDownload (url, params = {}) {
    let formData = new FormData()
    return service({
      method: 'post',
      url: PUBLIC_API + url,
      // 定义下载头
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      params,
      data: formData,
      // 从服务器下载流，需要设置blob
      responseType: 'blob'
    })
  }
}
